import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
export default class PollSubmitButton extends Component {
  view() {
    const state = this.attrs.state;
    return m(Button, {
      type: "button",
      className: "Button Button--primary Poll-submit",
      loading: state.loadingOptions,
      disabled: !state.hasSelectedOptions(),
      onclick: () => state.onsubmit()
    }, app.translator.trans('fof-polls.forum.poll.submit_button'));
  }
}
flarum.reg.add('fof-polls', 'forum/components/Poll/PollSubmitButton', PollSubmitButton);